import { faCheck, faTimesCircle } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import { FormattedMessage, injectIntl, WrappedComponentProps } from 'react-intl';
import { Alert, Button, ButtonGroup, FlexboxGrid, Message, Modal } from 'rsuite';
import { authHeader } from '../../../../../redux/helpers';
import { axiosService } from '../../../../../redux/services';

type Props = {
    intl: Record<string, any>;
    id: Array<number>;
    onHide: Function;
    show: boolean;
} & WrappedComponentProps;

type State = {
    isDeleting: boolean;
    hasError: boolean;
};
class DeleteDisplayModal extends React.Component<Props, State> {
    constructor(props) {
        super(props);

        this.state = {
            isDeleting: false,
            hasError: false,
        };

        this.deleteDisplay = this.deleteDisplay.bind(this);
    }

    deleteDisplay() {
        this.setState({
            isDeleting: true,
            hasError: false,
        });

        axiosService
            .getAxios()
            .delete('/devices/tcm-display', {
                headers: authHeader(),
                data: {
                    tabId: this.props.id,
                },
            })
            .then(() => {
                this.setState({
                    isDeleting: false,
                });

                Alert.success(
                    this.props.intl.formatMessage({
                        id: 'display.delete.success',
                    }),
                    5000
                );

                this.props.onHide(true);
            })
            .catch(err => {
                console.error(err);

                this.setState({
                    hasError: true,
                });
            });
    }

    render() {
        return (
            <Modal backdrop={true} show={this.props.show} onHide={() => this.props.onHide()}>
                <Modal.Header>
                    <Modal.Title>
                        <FormattedMessage id="display.delete.title" />
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body data-cy="ipcan-elements-display-delete-modal">
                    {this.state.hasError && (
                        <Message type="error" description={<FormattedMessage id="display.delete.error" />} />
                    )}
                    <FormattedMessage id="display.delete.message" />
                </Modal.Body>
                <Modal.Footer>
                    <FlexboxGrid align="middle" justify="end">
                        <FlexboxGrid.Item>
                            <ButtonGroup>
                                <Button
                                    onClick={() => this.props.onHide()}
                                    data-cy="ipcan-elements-display-delete-cancel"
                                    color="red">
                                    <FontAwesomeIcon icon={faTimesCircle} />
                                </Button>
                                <Button
                                    onClick={this.deleteDisplay}
                                    data-cy="ipcan-elements-display-delete-valid"
                                    appearance="primary">
                                    <FontAwesomeIcon icon={faCheck} />
                                </Button>
                            </ButtonGroup>
                        </FlexboxGrid.Item>
                    </FlexboxGrid>
                </Modal.Footer>
            </Modal>
        );
    }
}

export default injectIntl(DeleteDisplayModal);
